module.exports = __webpack_public_path__ + "static/media/flag-canada.0f1219d6.svg";